<template>
  <div class="container">
    <div class="first-bc-i">
      <!-- 首张背景图 -->
    </div>
    <div class="content" id="home">
      <div :class="{ 'nav-box-pos': navPos, 'nav-box': true }">
        <!-- 导航 -->
        <div class="nav-cn">
          <div class="nav-img">
            <!-- 图标 -->
            <img
              src="../../assets/logo.png"
              alt=""
              srcset=""
              width="60"
              height="60"
            />
            <span>新纪元</span>
          </div>
          <div class="nav-item">
            <!-- 导航条 -->
            <span
              :class="activeId == 'home' ? 'active' : ''"
              @click="setActive('home')"
            >
              <a href="#home">首页</a>
            </span>
            <span
              :class="activeId == 'product' ? 'active' : ''"
              @click="setActive('product')"
              ><a href="#product">产品展示</a></span
            >
            <span
              :class="activeId == 'my' ? 'active' : ''"
              @click="setActive('my')"
              ><a href="#my">关于我们</a></span
            >
            <span
              :class="activeId == 'new' ? 'active' : ''"
              @click="setActive('new')"
              ><a href="#new">新闻动态</a></span
            >
            <span
              :class="activeId == 'call' ? 'active' : ''"
              @click="setActive('call')"
              ><a href="#call">联系我们</a></span
            >
          </div>
        </div>
      </div>
      <div :class="{ title: true, 'title-pos': navPos }">
        <!-- Title -->
        <p>
          弈博道闸
        </p>
        <p>
          用心制造 成就品质
        </p>
      </div>
      <!--  -->
      <div class="other-box">
        <div class="item-box">
          <!-- 微信公众号 -->
          <div v-if="QRwho != 'G'">
            <h1>微信公众号</h1>
            <h3>弈博云</h3>
            <p>
              智慧社区管理平台、百强地产物业的选择，让无数业主享受便捷的社区生活，让数万物业人员实现移动化办公。
            </p>
          </div>
          <div v-else>
            <img
              src="../../assets/gzh.jpg"
              width="200"
              height="200"
              alt=""
              srcset=""
            />
          </div>
          <p>
            <el-button size="medium" type="success" @click="getQRcode('G')"
              >二维码</el-button
            >
          </p>
        </div>
        <div class="item-box">
          <!-- 微信服务号 -->
          <div v-if="QRwho != 'F'">
            <h1>微信服务号</h1>
            <h3>弈博EPOCH</h3>
            <p>
              为您实时提供产品信息、活动福利，时时刻刻把我们的努力与风采展示给您。
            </p>
          </div>
          <div v-else>
            <img
              src="../../assets/fwh.png"
              width="200"
              height="200"
              alt=""
              srcset=""
            />
          </div>
          <p>
            <el-button size="medium" type="success" @click="getQRcode('F')"
              >二维码</el-button
            >
          </p>
        </div>
        <div class="item-box">
          <!-- 产品说明书 -->
          <h1>文档中心</h1>
          <h3>文档</h3>
          <p>
            产品、平台、售后、商务、操作、等说明文档，为您便捷查找文档提供服务。
          </p>
          <p>
            <el-button size="medium" type="success" @click="gotoExplain"
              >点击前往</el-button
            >
          </p>
        </div>
      </div>
      <!--  -->
      <div id="product">
        <!-- item1 -->
        <div class="title-sty">
          <h1>产品展示</h1>
          <p>PRODUCTS</p>
        </div>
        <div class="product-item-box">
          <div class="product-content">
            <div class="product-header">
              <el-button
                  size="medium"
                  :class="{ 'btn-active': productActive == 'people' }"
                  @click="productBtnActive('people')"
              >智能人行通道闸</el-button
              >
              <el-button
                size="medium"
                :class="{ 'btn-active': productActive == 'gate' }"
                @click="productBtnActive('gate')"
                >智能道闸机</el-button
              >
              <el-button
                size="medium"
                :class="{ 'btn-active': productActive == 'system' }"
                @click="productBtnActive('system')"
                >智能停车场系统</el-button
              >
              <el-button
                size="medium"
                :class="{ 'btn-active': productActive == 'other' }"
                @click="productBtnActive('other')"
                >机芯/集成配件</el-button
              >
            </div>
            <div class="product-item">
              <div
                class="product-item-box"
                v-for="item in productItem"
                :key="item.productType"
                @click="productItemActive(item)"
              >
                <div>
                  <!-- image -->
                  <img
                    :src="item.url | imgUrl(productActive)"
                    alt=""
                    srcset=""
                    width="180"
                    height="180"
                  />
                </div>
                <p>
                  <!-- title -->
                  {{ item.title }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="my">
        <!-- item2 -->
        <div class="my-box">
          <div class="title-sty">
            <h1>关于我们</h1>
            <p>ABOUT EPOCH</p>
          </div>

          <div class="my-content">
            <h2>公司简介</h2>
            <p class="my-introduction">
              <span>成都新纪元高科技发展有限公司</span
              >位于美丽的锦水河畔，其现代化的花园式厂房占地面积1.5万余平米，拥有行业领先的专业化生产设备，主要从事道闸设备的研发及制造，专业生产智能停车场管理系统、人行通道闸等设备.我公司已通过ISO--9001：2015国际标准品质体系认证，以满足各种客户的多层次需求，全体职员本着“以人为本，以质取胜，持续改进，永续经营”的企业生产理念，产品已远销新加坡，泰国，马来西亚及东南亚其它国家。
              我们承诺：始终铭记为客户提供价格合理，质量优良的产品及服务，共创中国智能安防行业的美好明天...
            </p>
            <h2>服务保障</h2>
            <p class="my-introduction">
              <span>成都新纪元高科技发展有限公司</span
              >具有规范的管理制度和完善的质量管理体系，在“客户至上，服务第一”的公司宗旨引导下，公司全体同仁将竭尽所能，热情周到的为广大客户服务。为促进安防行业的发展，公司将责无旁贷。数年来，我公司以品种全、价格优、信誉好、服务佳等优势，吸引着来自全国各地的商家。充足的货源，方便快捷的配送服务，使新纪元高科成为安防行业中一颗耀眼的明珠！<span>一站式通道设备供应商</span>。
            </p>
            <div class="fuwu-box">
              <h3>十八年道闸生产行业经验</h3>
              <p>
                18年专业生产道闸、人行通道设备、智能停车场系统
                我们以"高性能的品质、低价位的成本"畅销全国各地
                为客户量身定制，打造不一样的产品
              </p>
              <h3>完善的质量管理体系品质一流</h3>
              <p>
                采购先进的生产设备，加快生产流程
                提高企业快速反应能力和控制节约成本
                产品尺寸公差小无披风毛刺，表面无脏污
              </p>
              <h3>专业的售后服务团队</h3>
              <p>
                技术专员服务，全程跟踪处理 处理完毕 电话回访
              </p>
            </div>
            <div class="details-box">
              <div class="details-item">
                <img
                  src="../../assets/serverimage/9hzv.png"
                  width="40"
                  height="40"
                  alt=""
                  srcset=""
                />
                <span>选材讲究</span>
              </div>
              <div class="details-item">
                <img
                  src="../../assets/serverimage/74ev.png"
                  width="40"
                  height="40"
                  alt=""
                  srcset=""
                />
                <span>领先工艺</span>
              </div>
              <div class="details-item">
                <img
                  src="../../assets/serverimage/uxzr.png"
                  width="40"
                  height="40"
                  alt=""
                  srcset=""
                />
                <span>类别丰富</span>
              </div>
              <div class="details-item">
                <img
                  src="../../assets/serverimage/1jxi.png"
                  width="40"
                  height="40"
                  alt=""
                  srcset=""
                />
                <span>服务保障</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="new">
        <div class="title-sty">
          <h1>新闻动态</h1>
          <p>NEWS</p>
        </div>
        <div class="new-content">
          <!-- 新闻详情 -->
          <el-table
            :data="newsList"
            size="medium"
            border
            stripe
            :cell-style="{ 'font-size': '18px' }"
            :header-cell-style="{ color: '#000', 'font-size': '20px' }"
            @row-click="rowClick"
          >
            <el-table-column label="标题" prop="title"></el-table-column>
            <el-table-column
              label="时间"
              prop="time"
              width="200"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 联系我们 -->
      <div id="call">
        <div class="title-sty">
          <h1>联系我们</h1>
          <p>CONTACT US</p>
        </div>
        <div class="call-content">
          <div class="item-box">
            <div class="item" v-for="(item, index) in callList" :key="index">
              <div class="img-box">
                <img
                  :src="item.url | callUrl"
                  width="60"
                  height="60"
                  alt=""
                  srcset=""
                />
              </div>
              <p>{{ item.title }}</p>
              <p>{{ item.phone }}</p>
            </div>
          </div>
          <div class="map-box">
            <div>
              <p>
                公司地址：成都市金牛区蜀西路42号（高新技术产业园区）B3 1-01号
              </p>
              <div class="map-item-box">
                <baidu-map
                  class="map"
                  :scroll-wheel-zoom="true"
                  :zoom="zoom"
                  :center="center"
                  @ready="mapReady"
                ></baidu-map>
              </div>
            </div>
            <div>
              <p>工厂地址：成都市新都区新繁镇（百度地图搜索“新纪元厂”）</p>
              <div class="map-item-box">
                <baidu-map
                  class="map"
                  :scroll-wheel-zoom="true"
                  :zoom="zoom1"
                  :center="center1"
                  @ready="mapReady"
                ></baidu-map>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div>
          <p>
            成都新纪元高科技发展有限公司 备案号：<a href="https://beian.miit.gov.cn/" target="_blank"><span
              >蜀ICP备06006284号-3</span></a>
            四川省成都市金牛区蜀西路42号（高新技术产业园区）5-3-1-01<br><br>
            电话：400-6130-100 邮箱：110c@souhu.com 网址：www.110c.com
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeId: "home",
      pOffsettop: "",
      mOffsettop: "",
      nOffsettop: "",
      cOffsettop: "",
      scrollTop: "", //滚动屏幕高度
      navPos: false,
      QRwho: "",
      productActive: "people",
      productItem: [],
      newsList: this.newsJSON,
      callList: [
        {
          url: "ldh_tzcp",
          title: "客服热线",
          phone: "028-86618811",
        },
        {
          url: "souji_n1vt",
          title: "手机号码",
          phone: "13980052600",
        },
        {
          url: "lwz_v5tx",
          title: "网址",
          phone: "www.110c.com",
        },
        {
          url: "ldz_v5jh",
          title: "邮箱",
          phone: "110c@souhu.com",
        },
      ],
      center: {
        lng: 103.996072,
        lat: 30.721384,
      },
      zoom: 20,
      center1: {
        lng: 103.954515,
        lat: 30.907434,
      },
      zoom1: 20,
    };
  },
  created() {
    this.showProduct();
  },
  mounted() {
    this.advisterScroll();
    let _this = this;
    this.$nextTick(() => {
      this.pOffsettop = document.getElementById("product").offsetTop;
      this.mOffsettop = document.getElementById("my").offsetTop;
      this.nOffsettop = document.getElementById("new").offsetTop;
      this.cOffsettop = document.getElementById("call").offsetTop;

      if (_this.$route.params.activeId) {
        _this.activeId = _this.$route.params.activeId;
        let a = document.createElement("a");
        a.href = "#" + _this.activeId;
        a.click();
      }
    });
  },
  filters: {
    imgUrl: function(val, productActive) {
      let url = require("@/assets/" + productActive + "/" + val + ".jpg");
      return url;
    },
    callUrl: function(val) {
      let url = require("@/assets/call/" + val + ".png");
      return url;
    },
  },
  watch: {
    scrollTop: function(val) {
      if (val > 200) {
        //导航定位
        this.navPos = true;
      } else {
        this.navPos = false;
      }
    },
  },
  methods: {
    setActive(id) {
      this.activeId = id;
    },
    //调取滚动事件
    advisterScroll() {
      let _this = this;
      window.addEventListener("scroll", function() {
        let sc = document.body.scrollTop + document.documentElement.scrollTop;
        _this.scrollTop = sc;
        if (sc >= _this.pOffsettop - 10 && sc < _this.mOffsettop - 10) {
          _this.activeId = "product";
        } else if (sc >= _this.mOffsettop - 10 && sc < _this.nOffsettop - 10) {
          _this.activeId = "my";
        } else if (sc >= _this.nOffsettop - 10 && sc < _this.cOffsettop - 10) {
          _this.activeId = "new";
        } else if (sc >= _this.cOffsettop - 10) {
          _this.activeId = "call";
        } else {
          _this.activeId = "home";
        }
      });
    },
    gotoExplain() {
      window.open("http://e.110c.net/e");
    },
    /*
     **  @description 获取二维码
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getQRcode(who) {
      if (this.QRwho == who) {
        this.QRwho = "";
      } else {
        this.QRwho = who;
      }
    },
    /*
     **  @description 产品点击事件
     **  @param {}
     **  @return
     **  @author shipingan
     */
    productBtnActive(who) {
      this.productActive = who;
      this.showProduct();
    },
    showProduct() {
      let list = this.productJSON.find((key) => key.type == this.productActive);
      if (list) {
        this.productItem = list.item;
      } else {
        this.productItem = [];
      }
    },
    /*
     **  @description 产品详情点击
     **  @param {}
     **  @return
     **  @author shipingan
     */
    productItemActive(item) {
      let url = this.$router.push({
        path: "/productItem",
        query: {
          productType: item.productType,
          productActive: this.productActive,
        },
      });
    },
    /*
     **  @description 新闻点击事件
     **  @param {}
     **  @return
     **  @author shipingan
     */
    rowClick(val) {
      this.$router.push({ path: "/newsItem", query: { id: val.time } });
    },
    /*
     **  @description 地图的获取
     **  @param {}
     **  @return
     **  @author shipingan
     */
    mapReady({ BMap }) {
      let addvister = BMap.Point(103.996, 30.721);
      // let icon = BMap.Icon("../../assets/call/ldz_v5jh.png",BMap.Size(30, 30));
      // BMap.Marker(addvister, {
      //   icon: icon,
      // }); // 创建标注
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  height: 100%;
  font-family: monospace;
  min-width: 1200px;
  .first-bc-i {
    position: fixed;
    top: 0;
    width: 100%;
    height: 70vh;
    z-index: -1;
    background: url("../../assets/gjko.jpg") no-repeat;
    background-size: 100% 100%;
    min-width: 1200px;
  }
  .content {
    // background-color: #fff;
    .nav-box {
      .nav-cn {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .nav-img {
          display: flex;
          line-height: 60px;
          color: #fff;
          font-size: 30px;
          font-weight: 700;
        }
        .nav-item {
          display: flex;
          span {
            line-height: 60px;
            font-size: 20px;
            margin: 0 15px;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            a {
              text-decoration: none;
              color: #ffffffaa;
              height: 100%;
            }
            a::after {
              content: "";
              display: block;
              transition: all 200ms ease-in-out 0s;
              border-top: 2px solid #fff;
              margin: -21px auto;
              width: 0;
            }
            &:hover a {
              color: #fff;
            }
            &:hover a::after {
              width: 100%;
            }
          }
          .active {
            a {
              color: #fff;
              &::after {
                width: 100%;
              }
            }
          }
        }
      }
    }
    // 固定导航样式
    .nav-box-pos {
      width: 100% !important;
      background-color: #fff;
      display: none;
      position: fixed;
      top: 0;
      z-index: 99999;
      box-shadow: 10px 0 10px #ccc;
      transition: all 500ms ease-in-out 0s;
      display: block;
      .nav-cn {
        .nav-img {
          color: #000;
        }
        .nav-item {
          span {
            a {
              color: #000;
            }
            &:hover a {
              color: #52d3aa;
            }
          }
          .active {
            a {
              color: #52d3aa;
              text-decoration: underline;
            }
          }
        }
      }
    }
    .title-pos {
      margin-top: 60px;
    }
    .title {
      animation: titleRotate 2s linear;
      padding: 15vh 0 30vh 0;
      @keyframes titleRotate {
        from {
          transform: rotateY(0);
        }
        to {
          transform: rotateY(360deg);
        }
      }
      p {
        color: #fff;
        margin: 0;
        font-size: 30px;
        &:nth-child(1) {
          font-size: 80px;
        }
      }
    }
    //
    .other-box {
      display: flex;
      justify-content: center;
      .item-box {
        width: 400px;
        height: 400px;
        background-color: #fff;
        box-sizing: border-box;
        box-shadow: 7px 14px 42px 3px rgba(163, 174, 184, 0.4);
        padding: 40px;
        &:nth-child(1):hover {
          background-color: #3b895d;
          color: #fff;
        }
        &:nth-child(1):hover .el-button {
          background-color: #3b895d;
          border-color: #fff;
        }
        &:nth-child(2):hover {
          background-color: #3e7091;
          color: #fff;
        }
        &:nth-child(2):hover .el-button {
          background-color: #3e7091;
          border-color: #fff;
        }
        &:nth-child(3):hover {
          background-color: #966234;
          color: #fff;
        }
        &:nth-child(3):hover .el-button {
          background-color: #966234;
          border-color: #fff;
        }
      }
    }
    #product {
      background-color: #fff;
      .title-sty {
        padding-bottom: 20px;
        h1 {
          margin-top: 0;
          padding: 140px 0 0 0;
        }
        p {
          font-size: 20px;
        }
      }
      .product-item-box {
        background-color: #4e565d;
        .product-content {
          width: 1200px;
          margin: 0 auto;
          .product-header {
            padding: 20px;
            display: flex;
            justify-content: space-around;
            .el-button {
              flex: 1;
              border: 1px dashed #fff;
              background-color: #4e565d;
              color: #fff;
            }
            .btn-active {
              background-color: #52d3aa;
              border: 1px solid #52d3aa;
            }
          }
          .product-item {
            width: 1200px;
            padding-bottom: 80px;
            margin: 0 auto;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            .product-item-box {
              width: 21%;
              margin: 2%;
              border-radius: 5px;
              box-sizing: border-box;
              background-color: #e4e4e4;
              padding: 20px 20px 0 20px;
              cursor: pointer;
              transition: all 500ms ease-in-out 0s;
              &:hover {
                transform: rotateY(30deg);
              }
            }
          }
        }
      }
    }
    #my {
      #product;
      .my-box {
        width: 1200px;
        margin: 0 auto;
      }
      .my-content {
        padding-bottom: 80px;
        h2 {
          text-align: left;
        }
        .my-introduction {
          font-size: 18px;
          letter-spacing: 2px;
          text-align: left;
          span {
            color: #52d3aa;
          }
        }
        .fuwu-box {
          padding-left: 20px;
          text-align: left;
          h3{
            color: #409eff;
          }
          p {
            padding-left: 10px;
          }
        }
        .details-box {
          display: flex;
          justify-content: center;
          .details-item {
            padding: 10px 20px;
            border: 2px solid #107fd8;
            margin: 20px;
            border-radius: 5px;
            display: flex;
            span {
              font-size: 30px;
            }
          }
        }
      }
    }
    #new {
      background-color: #727b84;
      color: #fff;
      .title-sty {
        padding-bottom: 20px;
        h1 {
          margin-top: 0;
          padding: 140px 0 0 0;
        }
        p {
          font-size: 20px;
        }
      }
      .new-content {
        width: 1200px;
        margin: 0 auto;
        padding: 20px 60px;
        padding-bottom: 100px;
      }
    }
    #call {
      #product;
      .call-content {
        padding-bottom: 100px;
        .item-box {
          width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          .item {
            padding: 20px;
            border: 1px solid #ccc;
            width: 140px;
            margin: 0 20px;
            border-radius: 8px;
            .img-box {
              border-bottom: 1px solid #ccc;
              padding-bottom: 20px;
            }
          }
        }
        .map-box {
          width: 1200px;
          margin: 0 auto;
          display: flex;
          margin-top: 40px;
          & > div {
            flex: 1;
            margin: 0 20px;
            .map {
              height: 360px;
              border: 1px solid #ccc;
            }
          }
        }
      }
    }
    .footer {
      background-color: #474747;
      color: #fff;
      div {
        width: 1200px;
        margin: 0 auto;
        padding: 20px;
        p {
          span {
            color: #4db690;
          }
        }
      }
    }
  }
}
a{
  text-decoration:none;
}
</style>
